import React, { useContext, useEffect, useState } from 'react';
import { Box, Container, VStack, Spinner, Tabs, TabList, TabPanels, Tab, TabPanel, Text } from '@chakra-ui/react';
import Navbar from '../compnents/Navbar';
import Footer from '../compnents/Footer';
import AuthContext from '../context/AuthContext';
import ThemeContext from '../context/ThemeContext';
import axios from 'axios';
import Loading from '../compnents/Loading';
import UploadYourFile from './UploadYourFile';
import SideBar from '../compnents/SideBar';
import DashboardFree from './DashboardPages/DashboardFree';
import FeatureUnlockContext from '../context/FeatureUnlockContext';
import DashboardRMownBookPaid from './DashboardPages/DashboardRMownBookPaid';
import DashboardRMwhoToCallPaid from './DashboardPages/DashboardRMwhoToCallPaid';
import DashboardRMPriorityScores from './DashboardPages/DashboardRMPriorityScores';
import DashboardRMriskRanking from './DashboardPages/DashboardRMriskRanking';
import DashboardRMsegments from './DashboardPages/DashboardRMsegments';
import DashboardAdminScoresPaid from './DashboardPages/DashboardAdminScoresPaid';
import DashboardAdminBiasBenchmarPaid from './DashboardPages/DashboardAdminBiasBenchmarPaid';
import DashboardAdminCustomerInsightsPaid from './DashboardPages/DashboardAdminCustomerInsightsPaid';
import DashboardRMCustomerInsights from './DashboardPages/DashboardRMCustomerInsights';
import LiveJobIdLoader from '../compnents/LiveJobIdLoader';
import JobProgressContext from '../context/JobProgressContext';
import DashboardComplianceScoresPaid from './DashboardPages/DashboardComplianceScoresPaid';
import DashboardComplianceBiasBenchmarkPaid from './DashboardPages/DashboardComplianceBiasBenchmarkPaid';
import DashboardHeadBiasBenchmarkPaid from './DashboardPages/DashboardHeadBiasBenchmarkPaid';
import DashboardViewOnlyBiasBenchmarkPaid from './DashboardPages/DashboardViewOnlyBiasBenchmarkPaid';
import DashboardRMdashboardPaid from './DashboardPages/DashboardRMdashboardPaid';
import DashboardComplianceDashboard from './DashboardPages/DashboardComplianceDashboardPaid';
import DashboardHeadDashboardPaid from './DashboardPages/DashboardHeadDashboardPaid';
import DashboardPortfolioDashboardPaid from './DashboardPages/DashboardPortfolioDashboardPaid';
import DashboardPortfolioCustomerInsightsPaid from './DashboardPages/DashboardPortfolioCustomerInsightsPaid';
import DashboardPortfolioBiasBenchmarkPaid from './DashboardPages/DashboardPortfolioBiasBenchmarkPaid';

const isProduction = process.env.NODE_ENV === "production";
const API_BASE_URL = isProduction ? process.env.REACT_APP_API_BASE_URL_PROD : process.env.REACT_APP_API_BASE_URL_DEV;

const Dashboard = () => {
    const { token, user, setUser, logout } = useContext(AuthContext);
    const { themeData } = useContext(ThemeContext);
    const { resetUnlocks } = useContext(FeatureUnlockContext);
    const { jobStatus, showLiveLoader } = useContext(JobProgressContext);
    const [loading, setLoading] = useState(true);

    // Extract theme colors with fallbacks
    const primaryColor = themeData?.colors?.primary || '#2B6CB0';
    // const secondaryColor = themeData?.colors?.secondary || '#2C5282';
    const backgroundColor = themeData?.colors?.background || '#F7FAFC';
    // const textColor = themeData?.colors?.text || '#1A202C';

    // Determine if theme is dark (midnight)
    const isDarkTheme = themeData?.id === 'midnight';

    // Text colors - fixed for dark theme
    const bodyTextColor = isDarkTheme ? '#E2E8F0' : 'gray.600';
    const headingTextColor = isDarkTheme ? '#F7FAFC' : 'gray.700';

    // Tab styles for dark theme
    const tabBg = isDarkTheme ? 'rgba(45, 55, 72, 0.6)' : 'white';
    const tabBorderColor = isDarkTheme ? 'rgba(66, 153, 225, 0.3)' : primaryColor;

    useEffect(() => {
        const fetchUser = async () => {
            if (!token || user) {
                setLoading(false);
                return;
            }

            try {
                const res = await axios.get(`${API_BASE_URL}/auth/check-user`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                console.log("checking user: ", res);

                if (res.status === 420) {
                    console.error('Invalid token');
                    resetUnlocks();
                    logout();
                    return;
                }

                setUser(res.data);
            } catch (error) {
                console.error('Error fetching user:', error);
                if (error.response?.status === 420) {
                    console.error('Token expired or invalid, logging out...');
                    resetUnlocks();
                    logout();
                }
            } finally {
                setLoading(false);
            }
        };

        fetchUser();
    }, [token, user, setUser, logout, resetUnlocks]);

    if (!token || (!user && loading)) {
        return (
            <Loading />
        );
    }

    if (user.role === 'admin' && jobStatus.loading) {
        return <Loading />;
    }

    if (!user) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column" justifyContent="center" alignItems="center" bg={backgroundColor}>
                <Spinner size="xl" color={primaryColor} />
            </Box>
        );
    }

    if (user && user.noOfFileUploads === 0) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column" bg={backgroundColor}>
                <Navbar />

                {(user.role === 'admin') && (
                    <UploadYourFile setUser={setUser} token={token} />
                )}

                {(user.role !== 'admin') && (
                    <Box
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        flex="1"
                        p={8}
                    >
                        <VStack spacing={4} textAlign="center">
                            <Text fontSize="xl" fontWeight="semibold" color={headingTextColor}>
                                No Dataset Available
                            </Text>
                            <Text fontSize="md" color={bodyTextColor} maxW="md">
                                Seems like your firm admin did not upload any datasets. Please contact admin and request to upload customer dataset.
                            </Text>
                        </VStack>
                    </Box>
                )}
            </Box>
        )
    }

    if (user.role === 'admin' && (showLiveLoader || jobStatus.hasIncompleteJobs)) {
        return (
            <Box minH="100vh" display="flex" flexDirection="column">
                <Navbar />
                <Box display="flex" flex="1" bg={backgroundColor}>
                    <SideBar />
                    <LiveJobIdLoader />
                </Box>
                <Footer />
            </Box>
        );
    }

    return (
        <Box minH="100vh" display="flex" flexDirection="column">
            <Navbar />
            <Box display="flex" flex="1" bg={backgroundColor}>
                <SideBar />

                <Container maxW="container.lg" flex="1">

                    {/* For admin */}
                    <VStack spacing={6} mt={5}>
                        {((user.subscription === 'free') && (user.role === 'admin')) && (
                            <DashboardFree />
                        )}

                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'admin')) && (
                            <Tabs variant="enclosed" colorScheme="blue" width="100%">
                                <TabList>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Customer Base Insights
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Individual Scores
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Bias Benchmark
                                    </Tab>
                                </TabList>

                                <TabPanels>
                                    <TabPanel>
                                        <DashboardAdminCustomerInsightsPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardAdminScoresPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardAdminBiasBenchmarPaid />
                                    </TabPanel>
                                </TabPanels>
                            </Tabs>
                        )}

                    </VStack>

                    {/* For RM */}
                    <VStack>
                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'rm')) && (
                            <Tabs variant="enclosed" colorScheme="blue" width="100%">
                                <TabList flexWrap="wrap">
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        RM Dashboard
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Customer Base Insights
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Own Book
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Who To Call
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Priority Scores
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Risk Ranking
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Segments
                                    </Tab>
                                </TabList>

                                <TabPanels>
                                    <TabPanel>
                                        <DashboardRMdashboardPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardRMCustomerInsights />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardRMownBookPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardRMwhoToCallPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardRMPriorityScores />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardRMriskRanking />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardRMsegments />
                                    </TabPanel>
                                </TabPanels>
                            </Tabs>
                        )}
                        {((user.subscription === 'free') && (user.role === 'rm')) && (
                            <Box py={10}>
                                <Text fontSize="lg" color={headingTextColor} textAlign="center" fontWeight="semibold">
                                    Purchase Subscription to access this page
                                </Text>
                            </Box>
                        )}
                    </VStack>

                    {/* for view_only */}
                    <VStack>
                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'view_only')) && (
                            <Tabs variant="enclosed" colorScheme="blue" width="100%">
                                <TabList>
                                    {/* <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Individual Scores
                                    </Tab> */}
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Bias Benchmark
                                    </Tab>
                                </TabList>

                                <TabPanels>
                                    {/* <TabPanel>
                                        <DashboardViewOnlyScoresPaid />
                                    </TabPanel> */}
                                    <TabPanel>
                                        <DashboardViewOnlyBiasBenchmarkPaid />
                                    </TabPanel>
                                </TabPanels>
                            </Tabs>
                        )}
                        {((user.subscription === 'free') && (user.role === 'view_only')) && (
                            <Box py={10}>
                                <Text fontSize="lg" color={headingTextColor} textAlign="center" fontWeight="semibold">
                                    Purchase Subscription to access this page
                                </Text>
                            </Box>
                        )}
                    </VStack>

                    {/* for compliance */}
                    <VStack>
                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'compliance')) && (
                            <Tabs variant="enclosed" colorScheme="blue" width="100%">
                                <TabList>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Compliance Dashboard
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Individual Scores
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Bias Benchmark
                                    </Tab>
                                </TabList>

                                <TabPanels>
                                    <TabPanel>
                                        <DashboardComplianceDashboard />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardComplianceScoresPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardComplianceBiasBenchmarkPaid />
                                    </TabPanel>
                                </TabPanels>
                            </Tabs>
                        )}
                        {((user.subscription === 'free') && (user.role === 'compliance')) && (
                            <Box py={10}>
                                <Text fontSize="lg" color={headingTextColor} textAlign="center" fontWeight="semibold">
                                    Purchase Subscription to access this page
                                </Text>
                            </Box>
                        )}
                    </VStack>

                    {/* for head */}
                    <VStack>
                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'head')) && (
                            <Tabs variant="enclosed" colorScheme="blue" width="100%">
                                <TabList>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Head of Advisory Dashboard
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Bias Benchmark
                                    </Tab>
                                </TabList>

                                <TabPanels>
                                    <TabPanel>
                                        <DashboardHeadDashboardPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardHeadBiasBenchmarkPaid />
                                    </TabPanel>
                                </TabPanels>
                            </Tabs>
                        )}
                        {((user.subscription === 'free') && (user.role === 'head')) && (
                            <Box py={10}>
                                <Text fontSize="lg" color={headingTextColor} textAlign="center" fontWeight="semibold">
                                    Purchase Subscription to access this page
                                </Text>
                            </Box>
                        )}
                    </VStack>

                    {/* for portfolio_adviser */}
                    <VStack>
                        {((user.subscription === 'pro' || user.subscription === 'business') && (user.role === 'portfolio_adviser')) && (
                            <Tabs variant="enclosed" colorScheme="blue" width="100%">
                                <TabList>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Dashboard
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Customer Insights
                                    </Tab>
                                    <Tab
                                        color={isDarkTheme ? bodyTextColor : 'gray.600'}
                                        _selected={{
                                            color: isDarkTheme ? '#63B3ED' : primaryColor,
                                            borderColor: tabBorderColor,
                                            bg: tabBg,
                                            fontWeight: 'semibold'
                                        }}
                                        _hover={{
                                            color: isDarkTheme ? '#90CDF4' : primaryColor
                                        }}
                                    >
                                        Bias Benchmark
                                    </Tab>
                                </TabList>

                                <TabPanels>
                                    <TabPanel>
                                        <DashboardPortfolioDashboardPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardPortfolioCustomerInsightsPaid />
                                    </TabPanel>
                                    <TabPanel>
                                        <DashboardPortfolioBiasBenchmarkPaid />
                                    </TabPanel>
                                </TabPanels>
                            </Tabs>
                        )}
                        {((user.subscription === 'free') && (user.role === 'portfolio_adviser')) && (
                            <Box py={10}>
                                <Text fontSize="lg" color={headingTextColor} textAlign="center" fontWeight="semibold">
                                    Purchase Subscription to access this page
                                </Text>
                            </Box>
                        )}
                    </VStack>

                </Container>
            </Box>
            <Footer />
        </Box>
    );
};

export default Dashboard;